// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const QuestionCircleOutline: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11c-.007 6.072-4.928 10.993-10.999 11H12Zm0-19.8a8.8 8.8 0 1 0 8.8 8.8A8.81 8.81 0 0 0 12 3.2Z" />
    <path d="M10.527 13.055a2.518 2.518 0 0 1 1.292-2.313l.012-.006c.86-.598 1.044-.779 1.044-1.404 0-.626-.615-.952-1.34-.952A4.52 4.52 0 0 0 9 9.197l.015-.01V7.315a6.451 6.451 0 0 1 2.77-.615h.033-.002C13.811 6.7 15 7.665 15 9.3a2.878 2.878 0 0 1-1.42 2.47l-.013.008c-.922.685-1.03 1.146-1.03 1.607v.28h-2.01v-.61Zm-.338 2.982a1.24 1.24 0 0 1 1.239-1.229h.014a1.277 1.277 0 0 1 1.42 1.178v.005c0 .687-.558 1.244-1.245 1.244h-.033.001-.064a1.238 1.238 0 0 1-1.331-1.195v-.003h-.001Z" />
  </SvgIcon>
);

QuestionCircleOutline.activeColor = 'inherit';
QuestionCircleOutline.muiName = 'QuestionCircleOutline';
